import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'
import { Link } from 'gatsby'
import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        exclusive={true}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        inProgress={true}
      >
        <SectionTitle>Usage</SectionTitle>
        <p>TBA</p>
        <Showcase
          site={data.site}
          title="Spinner"
          text={<p>TBA</p>}
          code={code.spinner}
        >
          <span class="c-spinner"></span>
          <span class="c-spinner__icon">
            <span>
              <i aria-hidden="true"></i>
              <i aria-hidden="true"></i>
              <i data-orbit="1"></i>
              <i data-orbit="2"></i>
            </span>
          </span>
        </Showcase>
        <Showcase
          site={data.site}
          title="Spinner with Context"
          text={<p>TBA</p>}
          code={code.spinner}
        >
          <span class="c-spinner"></span>
          <span class="c-spinner__icon">
            <span>
              <i aria-hidden="true"></i>
              <i aria-hidden="true"></i>
              <i data-orbit="1"></i>
              <i data-orbit="2"></i>
              <em>Loading Text</em>
            </span>
          </span>
        </Showcase>
        <SectionTitle>Microcopy</SectionTitle> <p>TBA</p>
      </Layout>
    </>
  )
}

export const code = {
  spinner: `<span class="c-spinner"></span>
  <span class="c-spinner__icon">
  <span>
    <i aria-hidden="true"></i>
    <i aria-hidden="true"></i>
    <i data-orbit="1"></i>
    <i data-orbit="2"></i>
  </span>
</span>
`,
  spinnerText: `<span class="c-spinner"></span>
<span class="c-spinner__icon">
  <span>
    <i aria-hidden="true"></i>
    <i aria-hidden="true"></i>
    <i data-orbit="1"></i>
    <i data-orbit="2"></i>
    <em>Loading Text</em>
  </span>
</span>
`,
}
